import React, { useEffect, useRef, useState } from "react";
import { toast } from "react-hot-toast";
import {
  FaFacebook,
  FaWhatsapp,
  FaLinkedin,
  FaTelegram,
  FaEnvelope,
  FaLink,
  FaShareNodes,
  FaXTwitter,
} from "react-icons/fa6";
import "./ShareProfileButtons.css";

const ShareProfileButtons = ({ url, name }) => {
  const [open, setOpen] = useState(false);
  const wrapperRef = useRef(null);

  const shareUrl = url || (typeof window !== "undefined" ? window.location.href : "");
  const shareText = name ? `Check out ${name}'s profile on TutorsLinks` : "Check out this profile on TutorsLinks";

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const openSharePopup = (shareLink) => {
    if (shareLink.startsWith("mailto:")) {
      window.location.href = shareLink;
    } else {
      window.open(shareLink, "_blank", "noopener,noreferrer,width=600,height=500");
    }
    setOpen(false);
  };

  const handleCopyLink = async () => {
    try {
      await navigator.clipboard.writeText(shareUrl);
      toast.success("Profile link copied!");
    } catch (err) {
      toast.error("Could not copy link");
    }
    setOpen(false);
  };

  const encodedUrl = encodeURIComponent(shareUrl);
  const encodedText = encodeURIComponent(shareText);

  const shareLinks = [
    {
      name: "Facebook",
      icon: <FaFacebook />,
      href: `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`,
      className: "share-icon-facebook",
    },
    {
      name: "X",
      icon: <FaXTwitter />,
      href: `https://twitter.com/intent/tweet?url=${encodedUrl}&text=${encodedText}`,
      className: "share-icon-x",
    },
    {
      name: "WhatsApp",
      icon: <FaWhatsapp />,
      href: `https://wa.me/?text=${encodedText}%20${encodedUrl}`,
      className: "share-icon-whatsapp",
    },
    {
      name: "LinkedIn",
      icon: <FaLinkedin />,
      href: `https://www.linkedin.com/sharing/share-offsite/?url=${encodedUrl}`,
      className: "share-icon-linkedin",
    },
    {
      name: "Telegram",
      icon: <FaTelegram />,
      href: `https://t.me/share/url?url=${encodedUrl}&text=${encodedText}`,
      className: "share-icon-telegram",
    },
    {
      name: "Email",
      icon: <FaEnvelope />,
      href: `mailto:?subject=${encodeURIComponent(shareText)}&body=${encodedUrl}`,
      className: "share-icon-email",
    },
  ];

  return (
    <div className="share-profile-wrapper" ref={wrapperRef}>
      <button
        type="button"
        className="circle-icon-btn share-toggle-btn"
        onClick={() => setOpen((prev) => !prev)}
        aria-haspopup="true"
        aria-expanded={open}
        title="Share this profile"
      >
        <FaShareNodes />
      </button>

      {open && (
        <div className="share-popover">
          <p className="share-popover-title">Share this profile</p>
          <div className="share-icons-grid">
            {shareLinks.map((link) => (
              <a
                key={link.name}
                href={link.href}
                onClick={(e) => {
                  e.preventDefault();
                  openSharePopup(link.href);
                }}
                className={`share-icon-btn ${link.className}`}
                title={`Share on ${link.name}`}
                aria-label={`Share on ${link.name}`}
              >
                {link.icon}
              </a>
            ))}

            <button
              type="button"
              className="share-icon-btn share-icon-copy"
              onClick={handleCopyLink}
              title="Copy link"
              aria-label="Copy profile link"
            >
              <FaLink />
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default ShareProfileButtons;
